import { AnimationController } from '@ionic/angular';

export const fadeTransition = (baseEl: any, opts?: any) => {
  const animationCtrl = new AnimationController();
  
  const enteringAnimation = animationCtrl
    .create()
    .addElement(opts.enteringEl)
    .duration(500) // Durée en ms
    .fromTo('opacity', '0', '1');

  const leavingAnimation = animationCtrl
    .create()
    .addElement(opts.leavingEl)
    .duration(100)
    .fromTo('opacity', '1', '0');

  return animationCtrl.create().addAnimation([enteringAnimation, leavingAnimation]);
};